import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import JSGroupEventCodeSnippet from "../_snippets/capture-group-event-code.mdx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`How you capture events with groups depends whether you're using the JavaScript Web SDK or not. `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`If you're using the JavaScript Web SDK (or snippet), you can call `}<inlineCode parentName="p">{`posthog.group()`}</inlineCode>{`  and all of that `}<strong parentName="p">{`session's`}</strong>{` events will be associated with that group.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you're using any other SDK (or the API), you need to pass the group information in the `}<inlineCode parentName="p">{`groups`}</inlineCode>{` parameter (or `}<inlineCode parentName="p">{`$groups`}</inlineCode>{` property) for `}<strong parentName="p">{`every event you capture`}</strong>{`.`}</p>
      </li>
    </ol>
    <p>{`Below are code examples of how to do it in our various SDKs.`}</p>

    <JSGroupEventCodeSnippet mdxType="JSGroupEventCodeSnippet" />
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Want to learn more about group analytics implementation differences?`}</strong>{` Check out our `}<a parentName="p" {...{
          "href": "/tutorials/frontend-vs-backend-group-analytics"
        }}>{`guide on frontend vs backend group analytics implementations`}</a>{`.`}</p>
    </blockquote>
    <p>{`Events must be `}<a parentName="p" {...{
        "href": "/docs/data/anonymous-vs-identified-events"
      }}>{`identified`}</a>{` to be associated with a group. If the `}<inlineCode parentName="p">{`$process_person_profile`}</inlineCode>{` event property ends up being set to `}<inlineCode parentName="p">{`false`}</inlineCode>{`, the event will not be associated with the group.`}</p>
    <p>{`It is `}<strong parentName="p">{`NOT`}</strong>{` possible to assign a single event to two groups of the same type. However, it is possible to assign an event to multiple groups as long as the groups are of different types.`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`// ❌ Not possible
posthog.group('company', 'company_id_in_your_db');
posthog.group('company', 'another_company_id_in_your_db');
posthog.capture('user_signed_up')

// ✅ Allowed
posthog.group('company', 'company_id_in_your_db');
posthog.group('channel', 'channel_id_in_your_db');
posthog.capture('user_signed_up')

`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`# ❌ Not possible
posthog.capture(
    'user_distinct_id',
    'user_signed_up',
    groups={
        'company': 'company_id_in_your_db',
        'company': 'another_company_id_in_your_db'
    }
)

# ✅ Allowed
posthog.capture(
    'user_distinct_id',
    'user_signed_up',
    groups={
        'company': 'company_id_in_your_db',
        'channel': 'channel_id_in_your_db'
    }
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`// ❌ Not possible
client.Enqueue(posthog.Capture{
    DistinctId: "user_distinct_id",
    Event: "user_signed_up",
    Groups: posthog.NewGroups().
        Set("company", "company_id_in_your_db").
        Set("company", "another_company_id_in_your_db"),
})

// ✅ Allowed
client.Enqueue(posthog.Capture{
    DistinctId: "user_distinct_id",
    Event: "user_signed_up",
    Groups: posthog.NewGroups().
        Set("company", "company_id_in_your_db").
        Set("channel", "channel_id_in_your_db"),
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`// ✅ Allowed
posthog.capture({
    event: 'user_signed_up',
    distinctId: 'user_distinct_id',
    groups: { 
        company: 'company_id_in_your_db',
        channel: 'channel_id_in_your_db'
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`// ❌ Not possible
PostHog::capture(array(
    'distinctId' => 'user_distinct_id',
    'event' => 'user_signed_up',
    '$groups' => array("company" => "company_id_in_your_db", "company" => "another_company_id_in_your_db")
));
// ✅ Allowed
PostHog::capture(array(
    'distinctId' => 'user_distinct_id',
    'event' => 'user_signed_up',
    '$groups' => array("company" => "company_id_in_your_db", "channel" => "channel_id_in_your_db")
));
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      